export default function Donation() {
  const paymentMethods = [
    {
      name: 'PayPal',
      icon: 'ri-paypal-line',
      color: 'bg-[#0070BA] hover:bg-[#005A9C]',
      url: 'https://paypal.me/YourPayPalUsername'
    },
    {
      name: 'Venmo',
      icon: 'ri-money-dollar-circle-line',
      color: 'bg-[#008CFF] hover:bg-[#0077D6]',
      url: 'https://venmo.com/YourVenmoUsername'
    },
    {
      name: 'Cash App',
      icon: 'ri-cash-line',
      color: 'bg-[#00D632] hover:bg-[#00BD2C]',
      url: 'https://cash.app/$YourCashAppTag'
    },
    {
      name: 'Zelle',
      icon: 'ri-bank-line',
      color: 'bg-[#6D1ED4] hover:bg-[#5A18B0]',
      url: 'mailto:your-email@example.com?subject=Zelle%20Donation%20for%20SwapHub'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
      <div className="max-w-4xl mx-auto text-center">
        {/* Heart Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full mb-6 shadow-lg">
          <i className="ri-heart-3-fill text-4xl text-white"></i>
        </div>

        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Keep SwapHub Running Strong 💛
        </h2>

        {/* Description */}
        <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto leading-relaxed">
          Love swapping on SwapHub? Drop a small donation to help us protect the marketplace, improve features, and keep the community thriving.
        </p>

        {/* Stats */}
        <div className="flex flex-wrap justify-center gap-8 mb-12">
          <div className="text-center">
            <div className="text-3xl font-bold text-amber-600">100%</div>
            <div className="text-sm text-gray-600">Community Funded</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-amber-600">$0</div>
            <div className="text-sm text-gray-600">Platform Fees</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-amber-600">24/7</div>
            <div className="text-sm text-gray-600">Support</div>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="mb-8">
          <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-6">
            Choose Your Preferred Payment Method
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {paymentMethods.map((method) => (
              <a
                key={method.name}
                href={method.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${method.color} text-white rounded-xl p-6 transition-all duration-300 transform hover:scale-105 hover:shadow-xl cursor-pointer group`}
              >
                <div className="flex flex-col items-center justify-center space-y-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors">
                    <i className={`${method.icon} text-2xl`}></i>
                  </div>
                  <span className="font-semibold text-sm whitespace-nowrap">{method.name}</span>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Custom Amount Section */}
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-2xl mx-auto mb-8">
          <h3 className="text-xl font-bold text-gray-900 mb-4">
            Every Contribution Helps! 🙏
          </h3>
          <div className="flex flex-wrap justify-center gap-3 mb-6">
            {['$5', '$10', '$25', '$50', '$100'].map((amount) => (
              <button
                key={amount}
                className="px-6 py-3 bg-gradient-to-r from-amber-400 to-orange-500 text-white font-semibold rounded-full hover:from-amber-500 hover:to-orange-600 transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
              >
                {amount}
              </button>
            ))}
          </div>
          <p className="text-sm text-gray-600">
            Your donation goes directly to server costs, security improvements, and new features
          </p>
        </div>

        {/* Impact Message */}
        <div className="bg-white/60 backdrop-blur-sm rounded-xl p-6 max-w-2xl mx-auto border border-amber-200">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
              <i className="ri-shield-check-line text-xl text-amber-600"></i>
            </div>
            <div className="text-left">
              <h4 className="font-bold text-gray-900 mb-2">Your Impact</h4>
              <p className="text-sm text-gray-700 leading-relaxed">
                Thanks to supporters like you, SwapHub remains <strong>free, safe, and ad-free</strong> for everyone. 
                Your generosity helps us maintain secure servers, fight fraud, and build features that make swapping easier and more enjoyable.
              </p>
            </div>
          </div>
        </div>

        {/* Thank You Note */}
        <p className="mt-8 text-sm text-gray-600 italic">
          Thank you for being part of our amazing community! 💚
        </p>
      </div>
    </section>
  );
}
